define(
({
  "alert": "Warnung",
  "okay": "Okay"
})
);
